<form
  [formGroup]="entryForm"
  (ngSubmit)="saveEntry()"
  autocomplete="on"
  class="container-grid"
  [ngStyle]="containerStyles"
>
	<div class="grid-first">
		<label for="tipo-entrada-opcion" class="form-label">Tipo de entrada*</label>
		<select
			id="tipo-entrada-opcion"
			class="form-control"
			[formControl]="tipoEntrada"
			*ngIf="movimiento == 'crear'"
		>
			<option *ngFor="let item of entriesType" [value]="item.id">
				{{ item.description }}
			</option>
		</select>
		<select
			id="tipo-entrada-opcion"
			class="form-control"
			formControlName="entry_type_id"
			*ngIf="movimiento !== 'crear'"
		>
			<option *ngFor="let item of entriesType" [value]="item.id">
				{{ item.description }}
			</option>
		</select>
	</div>
  <div *ngIf="movimiento !== 'crear'">
    <label for="noOperacion" class="form-label">No. de operación*</label>
    <input
      type="number"
      id="noOperacion"
      class="form-control"
      [value]="id"
      disabled
    />
  </div>
  <div>
    <label for="clave-recinto" class="form-label">Clave del recinto*</label>
    <input
      type="number"
      id="clave-recinto"
      class="form-control"
      formControlName="precinct_key"
    />
  </div>
  <div class="grid-first">
    <label for="total_tonnage" class="form-label">Tonelaje*</label>
    <input
      type="text"
      id="total_tonnage"
      class="form-control"
      formControlName="total_weight"
      maxlength="15"
      appBlockLetters
    />
    <span class="form-text text-danger" *ngIf="campoEsValido('total_weight')">
      Ingrese el tonelaje válido
    </span>
  </div>
  <div>
    <label for="piezas" class="form-label"
      >Piezas*</label
    >
    <input
      type="text"
      id="piezas"
      class="form-control"
      appOnlyNumbers
      [maxDigits]="10"
      formControlName="total_pieces"
    />
    <span class="form-text text-danger" *ngIf="campoEsValido('total_pieces')">
      Ingrese las pizas validas
    </span>
  </div>
  <div>
    <label for="fechaRecinto" class="form-label">Fecha de ingreso al recinto fiscalizado*</label>
    <input
      type="date"
      id="fechaRecinto"
      class="form-control"
      formControlName="admission_date"
    />
    <span
      class="form-text text-danger"
      *ngIf="campoEsValido('admission_date')"
    >
      Ingrese la fecha
    </span>
  </div>
  <app-amounts-by-input-locations
    class="subtitle"
    [movimiento]="movimiento"
    [locations]="locations"
    [entryTonnage]="entryForm.get('total_weight')?.value"
    [entryPieces]="entryForm.get('total_pieces')?.value"
    [entryDetail]="entryDetalle"
  ></app-amounts-by-input-locations>
  <div class="grid-all container-button">
    <button
      type="button"
      class="btn-lote me-5"
      (click)="regresar()"
      *ngIf="movimiento !== 'crear'"
    >
      Regresar
    </button>
    <button
      type="submit"
      class="btn-lote ms-5"
      *ngIf="movimiento !== 'detalle'"
    >
      Guardar
    </button>
  </div>
</form>
<app-overlay
  *ngIf="overlay"
  [icono]="iconoOverlay"
  [mensaje]="mensajeOverlay"
  [buttons]="buttons"
></app-overlay>
<app-overlay
  *ngIf="loading"
></app-overlay>
